// extracted by mini-css-extract-plugin
export default {"h":"style_h__hRwoG","sh":"style_sh__5krXr","p1":"style_p1__u77WB","btn2":"style_btn2__b+-xG"};